import styles from './SearchForm.module.scss';
import Search from '../Search';
import { usePageData } from '../../context';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useFormStore, Form } from '@ariakit/react';
import PropTypes from 'prop-types';

// Changes here also need to be made in IWantMenu.js
const triggerAnimation = setTriggerShake => {
  setTriggerShake(true);
  setTimeout(() => {
    setTriggerShake(false);
  }, 500);
};

const SearchForm = ({
  className,
  filters,
  placeholder,
  s = '',
  selectedFilterId,
}) => {
  const [triggerShake, setTriggerShake] = useState(false);
  const { rootLevel } = usePageData();
  const [values, setValues] = useState({ s });
  const form = useFormStore({ values, setValues });

  form.useValidate(() => {
    if (!form.getValue('s')) {
      triggerAnimation(setTriggerShake);
      form.setError('s', 'Bitte geben Sie einen Suchbegriff an');
    }
  });

  form.useSubmit(() => {
    const prefix = rootLevel?.slug === 'business' ? '/business' : '';
    const filter = filters?.find(({ id }) => id === selectedFilterId);
    const value = filter?.value || 'alle';

    window.open(`${prefix}/?s=${values.s}&filter=${value}&limit=50`, '_self');
  });

  return (
    <Form
      aria-label="Suche"
      className={classNames(styles.container, className)}
      resetOnSubmit={false}
      role="search"
      store={form}
      validateOnBlur={false}
      validateOnChange={false}
    >
      <Search
        onClearSearch={async () => {
          form.setValue('s', '');
        }}
        placeholder={placeholder}
        store={form}
        triggerShake={triggerShake}
      />
    </Form>
  );
};

SearchForm.propTypes = {
  className: PropTypes.string,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  placeholder: PropTypes.string,
  s: PropTypes.string,
  selectedFilterId: PropTypes.string,
};

export default SearchForm;
